import { Component, OnInit } from '@angular/core';
import { RoutesConst } from '@carm/shared/constants/const-routes';
import { last, takeUntil } from 'rxjs/operators';
import { combineLatest } from 'rxjs';
import { DashboardCountService } from '@carm/_core/dashboard-count/services/dashboard-count.service';
import { CarmRouter } from '@carm/_core/carm-router/services/carm-router.service';
import { BaseComponent } from '@carm/_utils/base.component';

@Component({
  selector: 'carm-rulings-widget',
  templateUrl: './rulings.component.html',
  styleUrls: ['./rulings.component.scss'],
})
export class RulingsWidgetComponent extends BaseComponent implements OnInit {

  viewAllRulingsUrl: string;
  ongoingRulingRequests: number;
  loading = true;

  constructor(private dashboardCountService: DashboardCountService, private carmRouter: CarmRouter) {
    super();
  }

  ngOnInit(): void {

    this.viewAllRulingsUrl = RoutesConst.Rulings_RulingsRequests;

    combineLatest([
      this.carmRouter.bn9$,
      this.carmRouter.bn15$,
    ])
    .pipe(takeUntil(this.destroy$))
    .subscribe(([bn9, programId]) => {

      this.loading = true;

      this.dashboardCountService.getRulingsCount(bn9, programId)
        .pipe(takeUntil(this.destroy$), last())
        .subscribe(getRulingsCountResponse => {

          this.ongoingRulingRequests = getRulingsCountResponse?.recordCount || 0
          this.loading = false;
        }, () => this.onError());
    }, () => this.onError());
  }

  private onError(): void {
    this.loading = false;
  }
}
